import styles from "./RegisterComponent.module.css";
import { useEffect, useRef, useState } from "react";
import Api from "../../../services/ApiService";
import { Card, CardBody, Row, Col, FloatingLabel, FormControl, Button, FormCheck, Spinner, FormSelect } from "react-bootstrap";
import Validator from "../../../services/Validator";
import CountryCodePhoneSelect from "../../shared/CountryCodePhoneSelect";
import UploadForm from "./UploadForm";
import CompanyTypeCards from "./CompanyTypeCards";

const RegisterComponentV2 = () => {

    const VALIDATOR = new Validator();
    const API = new Api();
    const [apiError, setApiError] = useState("");
    const [apiLoading, setApiLoading] = useState(false);
    const [stage, setStage] = useState("forms");

    const infoRef = useRef(null);
    const verbrauchRef = useRef(null);
    const iwantRef = useRef(null);
    //const situationRef = useRef(null);
    const uploadRef = useRef(null);
    const errorRef = useRef(null);
    const regDoneRef = useRef(null);
    const ticketDoneRef = useRef(null);
    const uploadMissingRef = useRef(null);
    
    const [fieldErros, setFieldErrors] = useState({});
    const [data, setData] = useState({
        company_type: "person",
        x_is_house_management: false,
        case: null,
        companyKw: false,
        contactPerson: "",
        name: "",
        lastName: "",
        email: "",
        country_id: "12",
        state_id: "",
        phone_country: "+43",
        vorwahl: "",
        phone: "",
        comment: "",
        situation: "",
        uploads: [],
        hasQuestion: false,
        question: "",
    });


    useEffect(() => {
        const handleMessage = (event) => {
            if (!/^https:\/\/([a-zA-Z\d-]+\.){0,}energiepool\.at$/.test(event.origin)) return;

            const {company_type, x_is_house_management, state_id} = event.data;

            if (company_type !== undefined) {
                setData(prev => ({
                    ...prev,
                    company_type: company_type
                }));
            }
            if (x_is_house_management !== undefined) {
                setData(prev => ({
                    ...prev,
                    x_is_house_management: x_is_house_management
                }));
            }
            if (state_id !== undefined) {
                setData(prev => ({
                    ...prev,
                    state_id: state_id
                }));
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        }
    }, [])


    useEffect(() => {
        window.setCompanyType = (val) => {
            setData(prev => ({ ...prev, company_type: val }));
        };
        window.setX_is_house_management = (val) => {
            setData(prev => ({ ...prev, x_is_house_management: val}));
        }
    }, []);


    useEffect(() => {
        if (data.company_type !== "") {
            if (infoRef.current) {
                infoRef.current.hidden = false;
            }
            //infoRef.current.scrollIntoView({behavior: "smooth"})
        }
        else {
            if (
                infoRef.current &&
                verbrauchRef.current &&
                iwantRef.current &&
                uploadRef.current
            ) {
                infoRef.current.hidden = true;
                verbrauchRef.current.hidden = true;
                iwantRef.current.hidden = true;
                //situationRef.current.hidden = true;
                uploadRef.current.hidden = true;
                resetData();
            }
        }
    }, [data.company_type])


    useEffect(() => {
        if (data.companyKw === true) {
            iwantRef.current.hidden = true;
            //situationRef.current.hidden = true;
            uploadRef.current.hidden = true;
            setData(prev => ({...prev,
                case: null,
                situation: "",
                uploads: []
            }));
            verbrauchRef.current.scrollIntoView({behavior: "smooth"});
        }
    }, [data.companyKw])


    useEffect(() => {
        if (data.case === 5) {
            //situationRef.current.hidden = true;
            uploadRef.current.hidden = true;
            setData(prev => ({...prev,
                situation: null,
                uploads: []
            }));
            iwantRef.current.scrollIntoView({behavior: "smooth"});
        }
    }, [data.case])

    
    // Reset data
    const resetData = () => {
        setData({
            company_type: "",
            x_is_house_management: false,
            case: null,
            companyKw: false,
            contactPerson: "",
            name: "",
            lastName: "",
            email: "",
            country_id: "12",
            state_id: "",
            phone_country: "+43",
            vorwahl: "",
            phone: "",
            comment: "",
            situation: "",
            uploads: []
        });
    }

    // Next button click handler
    const nextBtnHandler = (sectionId) => {
        var tmpError = {};
        var next = null; 

        // checks 
        if (sectionId === "info-form") {
            if (data.company_type === "") tmpError.company_type = true;
            if (data.name === "") tmpError.name = true;
            if (data.company_type === "person") {
                if (data.lastName === "") tmpError.lastName = true;
            } else {
                if (data.contactPerson === "") tmpError.contactPerson = true;
            }
            if (data.phone_country === "") tmpError.phone_country = true;
            if (data.vorwahl === "") tmpError.vorwahl = true;
            if (data.phone === "") tmpError.phone = true;
            if (!VALIDATOR.EmailValid(data.email)) tmpError.email = true;
            if (!VALIDATOR.isCountryIdValid(data.country_id)) tmpError.country_id = true;
            if (!VALIDATOR.isStateIdValid(data.state_id)) tmpError.state_id = true;
            
        }
        if (sectionId === "iwant-form") {
            if (data.case === null) tmpError.case = true;
        }

        if (Object.keys(tmpError).length > 0) return setFieldErrors(tmpError);
        

        // next handlers
        if (sectionId === "info-form") {
            if (data.x_is_house_management === true) return createTicket();
            if (data.company_type === "person") next = "iwant-form";
            else next = "verbrauch-form";
        }
        if (sectionId === "verbrauch-form") {
            if (data.companyKw === true) return createTicket();
            else next = "iwant-form";
        }
        if (sectionId === "iwant-form") {
            if (data.case === 5) return registerUser();
            else next = "upload-form"
        }
        if (sectionId === "situation-form") {
            next = "upload-form";
        }

        if (next !== null) {
            document.getElementById(next).removeAttribute('hidden');
            return document.getElementById(next).scrollIntoView({behavior: "smooth"});
        }

    }


    const createTicket = () => {
        setApiLoading(true);
        let dataForSending = {...data};
        dataForSending.phone = `${data.phone_country} ${data.vorwahl} ${data.phone}`;
        API.angebot_einholen(dataForSending)
            .then(() => {
                setStage("ticket_done"); 
                setApiLoading(false);
                ticketDoneRef.scrollIntoView({behavior: "smooth"});
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
                setApiLoading(false);
                errorRef.scrollIntoView({behavior: "smooth"});
            });
    }

     const registerUser = () => {
        setApiLoading(true);
        let dataForSending = {...data};
        dataForSending.phone = `${data.phone_country} ${data.vorwahl} ${data.phone}`;
        API.register_basic(dataForSending)
            .then(() => {
                setStage("reg_done"); 
                setApiLoading(false);
                regDoneRef.scrollIntoView({behavior: "smooth"});
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStage("error");
                setApiLoading(false);
                errorRef.scrollIntoView({behavior: "smooth"});
            })
    }


    return (
        stage === "forms" ?
            <>
                {/* <div id="companycards-form">
                    <CompanyTypeCards data={data} setData={setData} fieldErrors={fieldErros}/>
                </div> */}
                <div ref={infoRef} id="info-form" hidden>
                    <Card className={styles.shadowcard}>
                        <CardBody>
                            <p className={styles.formdescription}>Bitte geben Sie hier Ihre Daten an, damit wir mit Ihnen in Kontakt treten können.</p>
                            <FormControl type="hidden" value={data.company_type} id="company_type_field" />
                            <FormCheck hidden value={data.x_is_house_management} id="x_is_house_management_field" />
                            <Row className="mt-3">
                                <Col xs="12" md="6" xl="6">
                                    <FloatingLabel label={data.company_type === "company" ? "Unternehmensbezeichnung" : "Vorname"}>
                                        <FormControl 
                                            className={styles.inputform}
                                            placeholder={data.company_type === "company" ? "Unternehmensbezeichnung" : "Vorname"} 
                                            value={data.name}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, name: e.target.value})) }}
                                            isValid={data.name !== ""}
                                            isInvalid={fieldErros.name}
                                        />
                                    </FloatingLabel>
                                </Col>
                                <Col xs="12" md="6" xl="6" hidden={data.company_type === "company"}>
                                    <FloatingLabel label="Nachname">
                                        <FormControl 
                                            className={styles.inputform}
                                            placeholder="Nachname"
                                            value={data.lastName}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, lastName: e.target.value})) }}
                                            isValid={data.lastName !== ""}
                                            isInvalid={fieldErros.lastName}
                                        />
                                    </FloatingLabel>
                                </Col>
                                <Col xs="12" md="6" xl="6" hidden={data.company_type !== "company"}>
                                    <FloatingLabel label="Kontaktperson">
                                        <FormControl
                                            className={styles.inputform}
                                            placeholder="Kontaktperson"
                                            value={data.contactPerson}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, contactPerson: e.target.value})) }}
                                            isValid={data.contactPerson !== ""}
                                            isInvalid={fieldErros.contactPerson}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xs="12" md="8" xl="6">
                                    <FloatingLabel label="E-Mail">
                                        <FormControl 
                                            className={styles.inputform}
                                            placeholder="E-Mail"
                                            value={data.email}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, email: e.target.value})) }}
                                            isValid={VALIDATOR.EmailValid(data.email)}
                                            isInvalid={fieldErros.email}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xs="12" md="6" xl="6">
                                    <FloatingLabel label="Land">
                                        <FormSelect
                                            placeholder="Land"
                                            value={data.country_id}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, country_id: e.target.value}));}}
                                            isValid={VALIDATOR.isCountryIdValid(data.country_id)}
                                            isInvalid={fieldErros.country_id}
                                        >
                                            <option value="12">Österreich</option>
                                            <option value="57">Deutschland</option>
                                        </FormSelect>
                                    </FloatingLabel>
                                </Col>
                                <Col xs="12" md="6" xl="6" hidden={data.country_id !== "12"}>
                                    <FloatingLabel label="Bundesland">
                                        <FormSelect
                                            placeholder="Bundesland"
                                            value={data.state_id}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, state_id: e.target.value}));}}
                                            isValid={VALIDATOR.isStateIdValid(data.state_id)}
                                            isInvalid={fieldErros.state_id}
                                        >
                                            <option></option>
                                            <option value="1436">Burgenland</option>
                                            <option value="1437">Kärnten</option>
                                            <option value="1438">Niederösterreich</option>
                                            <option value="1439">Oberösterreich</option>
                                            <option value="1440">Salzburg</option>
                                            <option value="1441">Steiermark</option>
                                            <option value="1442">Tirol</option>
                                            <option value="1443">Vorarlberg</option>
                                            <option value="1444">Wien</option>
                                        </FormSelect>
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xs="12" md="6" xl="6">
                                    <CountryCodePhoneSelect data={data} setData={setData} />
                                </Col>
                                <Col xs="12" md="6" xl="6">
                                    <FloatingLabel label="Vorwahl">
                                        <FormControl
                                            className={styles.inputform}
                                            type="phone"
                                            placeholder="Vorwahl"
                                            value={data.vorwahl}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, vorwahl: e.target.value})) }}
                                            isValid={data.vorwahl !== "" && VALIDATOR.IsNumeric(data.vorwahl)}
                                            isInvalid={fieldErros.vorwahl}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xs="12" md="8" xl="6">
                                    <FloatingLabel label="Telefonnummer">
                                        <FormControl
                                            className={styles.inputform}
                                            type="phone"
                                            placeholder="Telefonnummer"
                                            value={data.phone}
                                            onChange={e => {setFieldErrors({}); setData(prev => ({...prev, phone: e.target.value})) }}
                                            isValid={data.phone !== "" && VALIDATOR.IsNumeric(data.phone)}
                                            isInvalid={fieldErros.phone}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button 
                                        disabled={apiLoading}
                                        onClick={() => nextBtnHandler("info-form")} 
                                        className={styles.nextbtn} 
                                        variant="energo"
                                    >
                                        {apiLoading? 
                                            <Spinner animation="border" /> :
                                            data.x_is_house_management === true? "Absenden":"Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                <div ref={verbrauchRef} className={styles.formsection} id="verbrauch-form" hidden>
                    <h1 className="text-center">Ihr Verbrauch:</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody>
                            <p className={styles.formdescription}>
                                Ich verbrauche pro Jahr mehr als 100.000 kWh Strom und/oder 400.000 kWh Gas.
                            </p>
                            <Row className="mt-5">
                                <Col>
                                    <FormCheck
                                        type="checkbox"
                                        label="Ja"
                                        checked={data.companyKw === true}
                                        onChange={() => {setFieldErrors({}); setData(prev => ({...prev, companyKw: true})) }}
                                    />
                                    <FormCheck
                                        type="checkbox"
                                        label="Nein"
                                        checked={!data.companyKw}
                                        onChange={() => {setFieldErrors({}); setData(prev => ({...prev, companyKw: false})) }}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button
                                        disabled={apiLoading}
                                        className={styles.nextbtn} 
                                        variant="energo"
                                        onClick={() => nextBtnHandler('verbrauch-form')}
                                    >
                                        {apiLoading?
                                            <Spinner animation="border" /> :
                                            data.companyKw ? "Absenden" : "Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                <div ref={iwantRef} id="iwant-form" className={styles.formsection} hidden>
                    <h1 className="text-center">Was ist Ihr Wunsch?</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody>
                            <p className={styles.formdescription}>Ich möchte ...</p>
                            <div className="p-3" style={fieldErros.case ? {border: "1px solid red"}:null}>
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Den Strom/Gas-Vertrag wechseln / ein Angebot einholen."
                                    checked={data.case === 6}
                                    onChange={() => {setFieldErrors({}); setData(prev => ({...prev, case: 6})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Strom/Gas neu anmelden."
                                    checked={data.case === 5}
                                    onChange={() => {setFieldErrors({}); setData(prev => ({...prev, case: 5})) }}
                                />
                            </div>
                            <br /><br />
                            <p className={styles.formdescription} hidden={data.case === undefined || data.case === null}>
                                {data.case === 6 ?
                                    <span>
                                        Ich möchte mich bei ENERGO registrieren. Derzeit besteht kein 
                                        laufender Energieliefervertrag auf meinen Namen. z.B. Umzug oder 
                                        Neuanmeldung
                                    </span> 
                                    :
                                    <span>
                                        Es besteht ein laufender Energieliefervertrag auf meinen Namen. 
                                        Ich möchte ein unverbindliches Angebot einholen und mehr Informationen 
                                        zur Dienstleistung von ENERGO.
                                    </span>
                                }
                                
                            </p>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button 
                                        disabled={apiLoading}
                                        className={styles.nextbtn} 
                                        variant="energo"
                                        onClick={() => nextBtnHandler("iwant-form")}
                                    >
                                        {apiLoading?
                                            <Spinner animation="border" /> :
                                            data.case === 5 ? "Absenden" : "Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>

                {/* COMMENTED OUT MAYBE WILL NEED FOR FUTURE USE
                
                <div ref={situationRef} id="situation-form" className={styles.formsection} hidden>
                    <h1 className="text-center">Wie ist der Stand der Dinge?</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody>
                            <p className={styles.formdescription}>
                                Um Ihnen bestmöglich helfen zu können, möchten wir gerne wissen in
                                welcher Situation Sie sich gerade befinden:
                            </p>
                            <div className="mt-3" style={fieldErros.situation? {border: "1px solid red"}:null}>
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                    value="Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"
                                    checked={data.situation === "Vertragskündigung des Stromanbieters MIT Folgeangebot, Tariferhöhung"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Vertragskündigung des Stromanbieterst OHNE Folgeangebot"
                                    value={"Vertragskündigung des Stromanbieterst OHNE Folgeangebot"}
                                    checked={data.situation === "Vertragskündigung des Stromanbieterst OHNE Folgeangebot"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Höheres Folgeangebot bereits angenommen"
                                    value={"Höheres Folgeangebot bereits angenommen"}
                                    checked={data.situation === "Höheres Folgeangebot bereits angenommen"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"
                                    value={"Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"}
                                    checked={data.situation === "Kürzlich umgezogen und einen teuren Neuvertrag abgeschlossen"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Börsenabhängiger Flex-/Floattarif"
                                    value={"Börsenabhängiger Flex-/Floattarif"}
                                    checked={data.situation === "Börsenabhängiger Flex-/Floattarif"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                                <FormCheck
                                    className={styles.formcheckbox}
                                    type="checkbox"
                                    label="Keine der genannten"
                                    value={"Keine der genannten"}
                                    checked={data.situation === "Keine der genannten"}
                                    onChange={e => {setFieldErrors({}); setData(prev => ({...prev, situation: e.target.value})) }}
                                />
                            </div>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <Button onClick={() => nextBtnHandler("situation-form")} className={styles.nextbtn} variant="energo">Weiter</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div> */}


                <div ref={uploadRef} id="upload-form" className={styles.formsection} hidden>
                    <h1 className="text-center">Ihre aktuellste Jahresabrechnung</h1>
                    <UploadForm data={data} setData={setData} setStage={setStage} setApiError={setApiError} />
                </div>
            </> :
            stage === "error" ?
                <div className="text-center" ref={errorRef}>
                    <h1>Fehler aufgetreten</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody className="text-center">
                            <p className={styles.formdescription + " text-danger"}>{apiError}</p>
                            <Button onClick={() => setStage("forms")} variant="warning" className={styles.nextbtn}>Zurück</Button>
                        </CardBody>
                    </Card>:
                </div>:
            stage === "reg_done"?
                <div className="text-center" ref={regDoneRef}>
                    <h1>ENERGO ENERGIEDIENSTLEISTUNGEN GmbH</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody className="text-center">
                            <p className={styles.formdescription}>
                                Vielen Dank für die Bekanntgabe Ihrer Daten! <br />
                                Wir haben Ihnen ein E-Mail gesendet, um Ihre E-Mail-Adresse
                                zu verifizieren.
                            </p>
                            {/*<Button onClick={() => setStage("forms")} variant="energo" className={styles.nextbtn}>Verstanden</Button> **/}
                        </CardBody>
                    </Card>
                </div>:
            stage === "ticket_done"?
                <div className="text-center" ref={ticketDoneRef}>
                    <h1>Kontaktaufnahme</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody className="text-center">
                            <p className={styles.formdescription}>
                                {
                                    data.companyKw?
                                        "Wir haben Ihre Daten erhalten und werden uns in Kürze bei Ihnen melden." :
                                        "Wir haben Ihre Daten erfasst und werden uns in Kürze mit einem Vergleichsangebot bei Ihnen melden."
                                }
                            </p>
                            {/*<Button onClick={() => setStage("forms")} variant="energo" className={styles.nextbtn}>Verstanden</Button> **/}
                        </CardBody>
                    </Card>
                </div>:
            stage === "upload_missing"?
                <div className="text-center" ref={uploadMissingRef}>
                    <h1>E-Mail gesendet!</h1>
                    <Card className={styles.shadowcard}>
                        <CardBody>
                            <p className={styles.formdescription}>
                                Vielen Dank für Ihr Interesse! <br />
                                Wir haben Ihnen zur Erinnerung ein E-Mail gesendet.
                            </p>
                            {/*<Button onClick={() => setStage("forms")} variant="energo" className={styles.nextbtn}>Verstanden</Button> **/}
                        </CardBody>
                    </Card>
                </div>:
        null
    )
}
export default RegisterComponentV2;